<!-- Login view -->
<template>
  <div class="row center-xs" style="min-height: 101vh">
    <div class="col-md-5 col-xs-11 start-xs">
      <div :style="{height: $mq === 'lg' ? '10vh' : '3vh'}" />

      <div class="row middle-xs" style="font-family: IndexText-Bold">
        <img class="bp-icon" src="../assets/favicon.png" />
        Big Picture
      </div>

      <auth-form />
    </div>
  </div>
</template>

<script>
export default {
  name: "Login"
};
</script>

<style scoped>
.bp-icon {
  width: var(--vw15px);
  margin-right: 5px;
}
</style>